import { AlignHorizontalCenter } from '@mui/icons-material';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Spin } from 'antd';
import React from 'react';

export default function CircularUnderLoad() {
  return (
    <div  className='contain-load'>
      <Spin  size="large">
        <div className="content" />
      </Spin>
    </div>
  );
}